<template>
  <div id="top-header">
    <dv-decoration-3 class="header-left-decoration" />
    <div class="center-title">数据开发中心 - 卓越运营指标监控大屏</div>
    <div class="full-screen">
      <span v-if="full" class="fa fa-compress fz20 pointer" @click="exitFullScreen"></span>
      <span v-else class="fa fa-expand fz20 pointer" @click="fullScreen"></span>
    </div>
    <dv-decoration-3 class="header-right-decoration" />
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  data() {
    return {
      full: false
    };
  },
  methods: {
    fullScreen() {
      let el = document.documentElement;
      let requestMethod = el.requestFullscreen || el.wekitRequestFullscreen || el.mozRequestFullscreen || el.msRequestFullscreen;
      if (requestMethod) {
        requestMethod.call(el);
      } else {
        let wscript = new ActiveXObject('WScript:Shell');
        wscript.SendKeys('{F11}');
      }
      this.full = true;
    },
    exitFullScreen() {
      let exitMethod = document.exitFullscreen || document.wekitExitFullscreen || document.mozExitFullscreen || document.msExitFullscreen;
      if (exitMethod) {
        exitMethod.call(document);
      } else {
        let wscript = new ActiveXObject('WScript:Shell');
        wscript.SendKeys('{F11}');
      }
      this.full = false;
    }
  }
};
</script>

<style lang="less">
#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration,
  .header-right-decoration {
    padding-top: 20px;
    width: 20%;
    height: 30px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
  }
  .full-screen {
    position: absolute;
    right: 30px;
    top: 55px;
  }
}
</style>
